import { ChangeEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useDebouncedCallback } from 'use-debounce';

import AsyncSwitch from '~/components/ui/AsyncSwitch';
import TextInput from '~/components/ui/TextInput';
import { useAppDispatch } from '~/hooks/useRedux';
import CreateQRContentBlockLayout from '~/pages/CreateQR/components/CreateQRContentBlockLayout/CreateQRContentBlockLayout';
import { updateQrCodeThunk } from '~/store/reducers/qr-code';
import { getQrCodeReducerData } from '~/store/reducers/qr-code/selectors';

/**
 * @deprecated
 * Use `PasswordProtectionBlock` instead.
 */
export default function PasswordProtectionBlockOldFlow() {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const qrCodeData = useSelector(getQrCodeReducerData);

  const [password, setPassword] = useState('');
  const [isPasswordProtected, setIsPasswordProtected] = useState(qrCodeData.data?.isPasswordProtected ?? false);

  const handleChangeIsPasswordProtected = (event: ChangeEvent<HTMLInputElement>) => {
    const isChecked = event.target.checked;
    setIsPasswordProtected(isChecked);

    if (!isChecked && password) {
      setPassword('');
    }

    dispatch(updateQrCodeThunk({ isPasswordProtected: isChecked }));
  };

  const updatePassword = useDebouncedCallback(() => {
    dispatch(updateQrCodeThunk({ password }));
  }, 300);

  const handleChangePassword = (e: ChangeEvent<HTMLInputElement>) => {
    setPassword(e.target.value);

    updatePassword();
  };

  return (
    <CreateQRContentBlockLayout type="passwordProtection" defaultExpanded={false}>
      <AsyncSwitch
        sx={{ marginBottom: '16px' }}
        label={t('basicTemplateLabels:passwordProtection.switchLabel')}
        onChange={handleChangeIsPasswordProtected}
        checked={isPasswordProtected}
      />
      <TextInput
        value={password}
        type="password"
        disabled={!isPasswordProtected}
        onChange={handleChangePassword}
        helperText={password?.length >= 128 ? t('other:maxLength', { maxLength: 128 }) : ''}
        inputProps={{ maxLength: 128 }}
        fullWidth
        label={t('basicTemplateLabels:passwordProtection.inputLabel')}
        placeholder={t('basicTemplateLabels:passwordProtection.inputPlaceholder')}
      />
    </CreateQRContentBlockLayout>
  );
}
